export const POST_LOGIN_REDIRECT_URI = 'post_login_redirect_uri';
//# sourceMappingURL=POST_LOGIN_REDIRECT_URI.js.map